<template>
  <div>
    <!-- Banner -->
    <v-banner color="secondary" outlined>
      <h3>درباره ما</h3>
      <v-breadcrumbs :items="items">
        <template v-slot:divider>
          <v-icon>mdi-chevron-left</v-icon>
        </template>
      </v-breadcrumbs>
    </v-banner>
    <!-- About us card and Contact us card -->
    <v-row v-for="item in customersAbout" :key="item.id" class="ma-3">
      <!-- About us card -->
      <v-col cols="12" sm="12" md="6">
        <v-card
          elevation="1"
          min-height="180"
          max-height="180"
          outlined
          class="pa-4 overflow-auto"
        >
          <div class="mb-2">
            <h3 align="center">درباره ما</h3>
          </div>
          <span class="d-inline-flex justify-end pa-1" style="font-weight: 900">
            {{ item.aboutus }}
          </span>
        </v-card>
      </v-col>
      <!-- Contact us card -->
      <v-col cols="12" sm="12" md="6">
        <v-card class="pa-4" elevation="1" min-height="180" outlined>
          <div>
            <h3 class="mb-4" align="center">ارتباط با ما</h3>
            <v-row class="pa-0 mx-auto my-2 justify-center">
              <!-- Phone number -->
              <v-col class="pa-1" align="center" cols="4" sm="4" md="2">
                <v-bottom-sheet v-model="sheet">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="1"
                      fab
                      icon
                      large
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-phone</v-icon>
                    </v-btn>
                  </template>
                  <v-sheet
                    height="auto"
                    class="bottomSheet rounded-t-xl mx-auto"
                  >
                    <div>
                      <v-list rounded class="py-2 px-2">
                        <v-list-item-group
                          v-model="selectedItem"
                          color="primary"
                        >
                          <v-list-item
                            :href="'tel: ' + item.addresses.data[0].phones[0]"
                          >
                            <v-list-item-title>
                              {{ item.addresses.data[0].phones[0] }}
                            </v-list-item-title>
                            <v-list-item-icon class="align-self-center">
                              <v-list-item-avatar rounded size="45">
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/3059/3059606.png"
                                  alt="call"
                                />
                              </v-list-item-avatar>
                            </v-list-item-icon>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </div>
                  </v-sheet>
                </v-bottom-sheet>
              </v-col>
              <!-- Mobile number -->
              <v-col class="pa-1" align="center" cols="4" sm="4" md="2">
                <v-bottom-sheet v-model="sheet2">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="1"
                      fab
                      icon
                      large
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-cellphone</v-icon>
                    </v-btn>
                  </template>
                  <v-sheet
                    height="auto"
                    class="bottomSheet rounded-t-xl mx-auto"
                  >
                    <div>
                      <v-list rounded class="py-2 px-2">
                        <v-list-item-group
                          v-model="selectedItem"
                          color="primary"
                        >
                          <v-list-item
                            :href="'tel: ' + item.addresses.data[0].mobiles[0]"
                          >
                            <v-list-item-title>
                              {{ item.addresses.data[0].mobiles[0] }}
                            </v-list-item-title>
                            <v-list-item-icon class="align-self-center">
                              <v-list-item-avatar rounded size="45">
                                <img
                                  src="https://cdn-icons-png.flaticon.com/512/2313/2313742.png"
                                  alt="mobile call"
                                />
                              </v-list-item-avatar>
                            </v-list-item-icon>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </div>
                  </v-sheet>
                </v-bottom-sheet>
              </v-col>
              <!-- Instagram address -->
              <v-col class="pa-1" align="center" cols="4" sm="4" md="2">
                <v-btn
                  :href="'https://www.instagram.com/' + item.instagram"
                  elevation="1"
                  fab
                  icon
                  large
                >
                  <v-icon color="primary">mdi-instagram</v-icon>
                </v-btn>
              </v-col>
              <!-- Whatsapp address -->
              <v-col class="pa-1" align="center" cols="4" sm="4" md="2">
                <v-btn
                  :href="
                    'https://wa.me/' + item.whatsapp + '/?text=urlencodedtext'
                  "
                  elevation="1"
                  fab
                  icon
                  large
                >
                  <v-icon color="primary">mdi-whatsapp</v-icon>
                </v-btn>
              </v-col>
              <!-- Map navigation -->
              <v-col class="pa-1" align="center" cols="4" sm="4" md="2">
                <v-btn
                  :href="
                    'https://www.google.com/maps/place/' +
                    item.addresses.data[0].lat +
                    ',' +
                    item.addresses.data[0].long +
                    '/@' +
                    item.addresses.data[0].lat +
                    ',' +
                    item.addresses.data[0].long +
                    ',17z?hl=en-IR'
                  "
                  elevation="1"
                  fab
                  icon
                  large
                >
                  <v-icon color="primary">mdi-map-marker-outline</v-icon>
                </v-btn>
              </v-col>
              <!-- Working hours -->
              <v-col class="pa-1" align="center" cols="4" sm="4" md="2">
                <v-bottom-sheet v-model="sheet3">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      elevation="1"
                      fab
                      icon
                      large
                      v-bind="attrs"
                      v-on="on"
                    >
                      <v-icon color="primary">mdi-clock-outline</v-icon>
                    </v-btn>
                  </template>
                  <v-sheet
                    height="auto"
                    class="bottomSheet rounded-t-xl mx-auto"
                  >
                    <div>
                      <v-list rounded class="py-2 px-2">
                        <v-list-item-group
                          v-model="selectedItem"
                          color="primary"
                        >
                          <v-list-item
                            v-for="(schedule, i) in item.addresses.data[0]
                              .schedules"
                            :key="i"
                          >
                            <v-list-item-title>
                              {{ schedule.day }}
                            </v-list-item-title>
                            <v-list-item-title
                              class="align-self-center"
                              align="end"
                            >
                              {{ schedule.time_open }} الی
                              {{ schedule.time_close }}
                            </v-list-item-title>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </div>
                  </v-sheet>
                </v-bottom-sheet>
              </v-col>
            </v-row>
          </div>
        </v-card>
      </v-col>
      <!-- Location -->
      <v-col cols="12">
        <Mapbox :customersAbout="customersAbout" />
      </v-col>
      <!-- Tags -->
      <v-col cols="12" sm="12" md="12">
        <v-card elevation="3" class="pa-4">
          <h3>برچسب ها</h3>
          <v-chip-group class="mt-2 mb-2">
            <v-chip
              v-for="(tag, i) in item.tags"
              :key="i"
              color="info"
              outlined
              link
            >
              #{{ tag.name }}
            </v-chip>
          </v-chip-group>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import Mapbox from "@/components/mapbox.vue";
import LoadingOverlay from "@/layouts/LoadingOverlay-temp-2.vue";
export default {
  props: {
    customersAbout: {},
  },
  data() {
    return {
      items: [
        {
          text: "خانه",
          disabled: false,
          href: "/",
        },
        {
          text: "درباره ما",
          disabled: false,
          href: "about-us",
        },
      ],
      // customers: [],
      selectedItem: 1,
      sheet: false,
      sheet2: false,
      sheet3: false,
      location: window.document.location.host.replace("www.", ""),
      type: "scale",
      show: null,
    };
  },
  components: {
    Mapbox,
    LoadingOverlay,
  },
  methods: {
    // async booths() {
    //   var self = this;
    //   let response = await self.axios.get(
    //     "https://namya.ir/api/v1/businesses/booths/48"
    //   );
    //   // console.log(self.$route.params.name);
    //   self.customers = response.data;
    //   this.title = this.customers.data.name;
    //   this.keywords = this.customers.data.tags.map((tags) => `${tags.name}`);
    //   this.description = this.customers.data.aboutus;
    //   localStorage.setItem("ID", JSON.stringify(self.customers.data.id));
    //   this.tags = this.customers.data.tags;
    // },
  },
  metaInfo() {
    return {
      title: "نامیا",
      titleTemplate: "%s | تماس با ما",
    };
  },
  head: {
    link: [
      {
        rel: "canonical",
        href: "https://namya.ir/",
        id: "canonical",
      },
    ],
    meta: [
      { charset: "utf-8" },
      {
        name: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        name: "keywords",
        content:
          "نامیا،کارت ویزیت دیجیتال،وب سایت اختصاصی ،شبکه اجتماعی ،کارت ویزیت آنلاین ،باشگاه مشتریان ،درخواست ها ،نوبت دهی آرایشگاه ،کارواش",
      },
      { name: "twitter:card", content: "summary" },
      {
        name: "twitter:site",
        content: "",
      },
      {
        name: "twitter:title",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        name: "twitter:description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      // Your twitter handle, if you have one.
      { name: "twitter:creator", content: "" },
      {
        name: "twitter:image:src",
        content:
          "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },

      // Google / Schema.org markup:
      {
        itemprop: "name",
        content: "نامیا | اولین نمایشگاه مجازی کسب و کارها ",
      },
      {
        itemprop: "description",
        content:
          "نامیا نمایشگاه مجازی کسب و کارهاست ، با نامیا کسب و کارت رو آنلاین کن ،نامیا اولین شبکه اجتماعی کسب و کارهاست ایجاد وب سایت اختصاصی ،کارت ویزیت دیجیتال",
      },
      {
        itemprop: "image",
        content:
          "https://namya.ir/repository/businesses/300_300/48/14010828114138-542.png",
      },
    ],
  },
  mounted() {
    this.show = true;
  },
  created() {
    // this.booths();
  },
};
</script>

<style scoped>
.v-application .my-6 {
  margin-bottom: 15px !important;
}

* >>> .v-dialog {
  box-shadow: inherit !important;
}

.v-list-item {
  height: 50px !important;
}
.v-btn--is-elevated {
  box-shadow: inherit !important;
}

.theme--light.v-btn:hover::before {
  opacity: 0.05 !important;
}

.theme--light.v-list {
  background: rgb(255 255 255 / 0%);
}

.v-btn--fab.v-size--large {
  height: 60px !important;
  width: 60px !important;
}

* >>> .v-slide-group__next,
.v-slide-group__prev {
  min-width: 45px !important;
}

@media (min-width: 768px) {
  .col-md-2 {
    flex: 0 0 16.6666666667%;
    max-width: 16.6666666667%;
  }
}

@media (280px <= width < 360px) {
  .bottomSheet {
    width: 240px !important;
  }
}

@media (360px <= width <= 412px) {
  .bottomSheet {
    width: 310px !important;
  }
}

@media (412px < width <= 820px) {
  .bottomSheet {
    width: 400px !important;
  }
}

@media (min-width: 821px) {
  .bottomSheet {
    width: 700px !important;
  }
}
</style>
